/* tslint:disable */
/* eslint-disable */
/**
 * Marsinet API
 * Esta API es utilizada tanto por Marsinet como por MarsiConnect. Proporciona todos los endpoints actualizados y documentación detallada, incluyendo ejemplos de datos y mocks de prueba para verificar el comportamiento de cada llamada.
 *
 * OpenAPI spec version: 5.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { FieldConditionDto } from './field-condition-dto';
/**
 *
 *
 * @export
 * @interface SurveyFieldDto
 */
export interface SurveyFieldDto {
  /**
   * Name of the field.
   *
   * @type {string}
   * @memberof SurveyFieldDto
   * @example Satisfaction Score
   */
  name: string;

  /**
   * Human-readable description of the field.
   *
   * @type {string}
   * @memberof SurveyFieldDto
   * @example Rate your overall satisfaction from 1 to 5.
   */
  description?: string;

  /**
   * Type of the field.
   *
   * @type {string}
   * @memberof SurveyFieldDto
   * @example text
   */
  type: SurveyFieldDtoTypeEnum;

  /**
   * Whether this field is required.
   *
   * @type {boolean}
   * @memberof SurveyFieldDto
   * @example true
   */
  required: boolean;

  /**
   * Allowed values for the field. If defined, the field is select (or multi select if type is  string_array) or an open field.
   *
   * @type {Array<string>}
   * @memberof SurveyFieldDto
   * @example ["very_satisfied","satisfied","neutral","dissatisfied"]
   */
  allowed_values?: Array<string>;

  /**
   * If set, this field is only shown when the condition is met.
   *
   * @type {FieldConditionDto}
   * @memberof SurveyFieldDto
   */
  condition?: FieldConditionDto;
}

/**
 * @export
 * @enum {string}
 */
export enum SurveyFieldDtoTypeEnum {
  Text = 'text',
  Number = 'number',
  Select = 'select',
  MultiSelect = 'multi_select',
}
